import axios from 'axios';

// Call the same-origin nginx proxy on admin.autovertest.com
const API_BASE = '/api/saas';

// The Access-Control backend verifies this Freecomers admin JWT with Laravel
// (GET /api/v1/admin/verify-token). Same token the other admin services send.
const saasApi = axios.create({ baseURL: API_BASE });
saasApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('cookies');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const fetchFestivals = async (search = '') => {
  const params = search ? { search } : {};
  const res = await saasApi.get(`/festivals`, { params });
  return res.data;
};

export const toggleFestivalSaaS = async (eventId, isEnabled) => {
  const res = await saasApi.put(`/festivals/${eventId}/toggle-saas`, { isEnabled });
  return res.data;
};

export const fetchFestivalArchitecture = async (eventId) => {
  const res = await saasApi.get(`/festivals/${eventId}/architecture`);
  return res.data;
};

export const toggleFestivalModule = async (eventId, moduleId, isEnabled) => {
  const res = await saasApi.post(`/festivals/${eventId}/modules/${moduleId}/toggle`, { isEnabled });
  return res.data;
};

export const updateGroupPermissionMatrix = async (eventId, moduleId, groupKey, permissionShortKeys) => {
  const res = await saasApi.put(`/festivals/${eventId}/modules/${moduleId}/matrix`, {
    groupKey,
    permissionShortKeys,
  });
  return res.data;
};

export const updateFestivalSettings = async (eventId, settings) => {
  const res = await saasApi.put(`/festivals/${eventId}/settings`, settings);
  return res.data;
};

export const getFestivalLaunchToken = async (eventId) => {
  const res = await saasApi.post(`/festivals/${eventId}/launch-token`);
  return res.data;
};
